import mainApi from "./mainApi";

const localTexts = {
    en: {
        dashboard_title: "My Favorite Plan",
        dashboard_subtitle: "Here are your saved quotes",
        dashboard_new_quote: "New Quote",
        dashboard_create_plan: "Create a New My Favorite Plan",
        dashboard_table_plan_name: "Plan Name",
        dashboard_table_created_date: "Created Date",
        dashboard_table_updated_date: "Updated Date",
        dashboard_table_dependents: "Dependents",
        dashboard_table_gender: "Gender",
        dashboard_table_maximum_coverage: "Maximum Coverage",
        dashboard_table_graphical_coverage: "Geographical Coverage",
        dashboard_table_provider_network: "Provider Network",
        dashboard_table_outpatient_benefits: "Outpatient benefits",
        dashboard_table_deductible_reduction: "Deductible Reduction",
        dashboard_table_preventive_checkup: "Preventative health check-ups",
        dashboard_table_maternity_complications: "Maternity complications benefits",
        dashboard_table_newborn_maternity: "Newborn and maternity complications",
        dashboard_table_total_times_used: "Total Times Used",
        dashboard_table_actions: "Actions",
        dashboard_action_use: "Use plan",
        dashboard_action_edit: "Edit plan",
        dashboard_action_download: "Download premium table",
        dashboard_table_download_premium_table: "Download premium table",
        dashboard_action_delete: "Delete plan",
        dashboard_download_error_title: "Download failed",
        dashboard_download_error_text: "It is not possible to download the document. Please try again.",
        dashboard_empty_title: "You don't have any favorite plans yet.",
        dashboard_empty_text: "Create your first one!",
        dashboard_pagination_label: "Page",
        dashboard_card_total: "Total of Templates",
        dashboard_card_used: "Used Templates",
        dashboard_card_edited: "Edited Templates",
        dashboard_card_cancelled: "Cancelled Templates",
        dashboard_card_vs_last_month: "vs. last month",
        dashboard_search_placeholder: "Search...",
        dashboard_search_clear: "Clear search",
        dashboard_filter_by: "Filter by:",
        dashboard_filter_country: "By Country",
        dashboard_filter_creation_date: "By Creation Date",
        dashboard_filter_created_within: "By Date",
        dashboard_filter_last_month: "Last month",
        dashboard_filter_last_3_months: "Last 3 months",
        dashboard_filter_last_6_months: "Last 6 months",
        dashboard_filter_last_year: "Last year",
        dashboard_filter_all_time: "All time",
        dashboard_sort_placeholder: "Sort",
        dashboard_sort_created_desc: "Created ↓",
        dashboard_sort_created_asc: "Created ↑",
        dashboard_sort_updated_desc: "Updated ↓",
        dashboard_sort_updated_asc: "Updated ↑",
        dashboard_reset_filter: "Reset Filter",
        dashboard_delete_title: "Are you sure you want to delete?",
        dashboard_delete_text: "This action cannot be undone.",
        dashboard_delete_confirm: "Accept",
        dashboard_delete_cancel: "Cancel",
        dashboard_delete_close: "Close",
        dashboard_delete_retry: "Retry",
        dashboard_delete_loading_title: "Deleting…",
        dashboard_delete_loading_text: "Please wait while we delete your plan.",
        dashboard_delete_success_title: "Plan deleted",
        dashboard_delete_success_text: "The plan has been deleted successfully.",
        dashboard_delete_error_title: "Something went wrong",
        dashboard_delete_error_text: "We couldn’t delete the plan. Please try again.",
        favorite_plan_form_base_info_title: "Base Information",
        favorite_plan_form_base_info_subtitle: "Fill out the information below to start building a personalized plan",
        favorite_plan_form_field_age: "Age",
        favorite_plan_form_field_needs_dependent: "Do you need to add a dependent?",
        favorite_plan_form_field_age_range_error: "Age must be between 18 and 75 years inclusive.",
        favorite_plan_form_load_error_title: "We couldn’t load this template",
        favorite_plan_form_load_error_text: "Something went wrong while loading your favorite plan. Please try again.",
        favorite_plan_form_load_error_retry: "Retry",
        favorite_plan_form_back_to_home: "Back to Home",
        favorite_plan_form_unsaved_changes_message: "You have unsaved changes. Are you sure you want to leave this page? Your changes will be lost.",
        favorite_plan_form_leave: "Leave",
        favorite_plan_form_stay: "Stay",
        favorite_plan_button_save: "Save to My Favorite Plans",
        favorite_plan_button_update: "Update My Favorite Plan",
        favorite_plan_summary_incomplete_tooltip: "Complete all steps before saving",
        favorite_plan_summary_stale_price_tooltip: "Update the price before saving",
        favorite_plan_save_title: "Save to My Favorite Plans",
        favorite_plan_save_button: "Save",
        favorite_plan_save_cancel: "Cancel",
        favorite_plan_save_retry: "Retry",
        favorite_plan_save_suggested: "Suggested Name",
        favorite_plan_save_placeholder: "Name",
        favorite_plan_save_loading_title: "Saving…",
        favorite_plan_save_loading_text: "Please wait while we save your plan.",
        favorite_plan_save_success_title: "Plan saved",
        favorite_plan_save_success_text: "Your plan was saved to My Favorite Plans.",
        favorite_plan_save_error_title: "Something went wrong",
        favorite_plan_save_error_text: "We couldn’t save your plan. Please try again.",
        favorite_plan_save_go_to_dashboard: "Go to dashboard",
        favorite_plan_name_field_label: "Name of My Favorite Plan",
        favorite_plan_save_name_available: "Name available",
        favorite_plan_save_name_checking: "Checking name availability…",
        favorite_plan_save_name_taken: "This name is already in use",
        favorite_plan_save_name_check_failed: "We couldn’t check this name",
        favorite_plan_save_name_invalid_length: "Name must be between 5 and 50 characters",
        favorite_plan_save_name_invalid_chars: "Name must only contain letters and numbers",
        favorite_plan_update_title: "Update My Favorite Plan",
        favorite_plan_update_button: "Update",
        favorite_plan_update_loading_title: "Updating…",
        favorite_plan_update_loading_text: "Please wait while we update your plan.",
        favorite_plan_update_success_title: "Plan updated",
        favorite_plan_update_success_text: "Your plan was updated in My Favorite Plans.",
        favorite_plan_update_error_text: "We couldn’t update your plan. Please try again.",
        fav_plan_stale_benefits_message_generic: "Some benefits in this plan are no longer available. Please edit the plan before using it.",
        fav_plan_stale_benefits_acknowledge: "OK",
        home_welcome_back: "Welcome back",
        home_phrase_one: "PLANS DESIGNED FOR YOU,",
        home_phrase_two: "BACKED BY VUMI®",
        home_phrase_three: "With <strong>My VIP Care™</strong>, you personalize coverage, choose benefits and fine-tune every detail based on what you truly value.",
        navbar_logout: "Log Out",
        menu_back_to_home: "Back to Home",
        menu_options_pending_fields: "This step has pending fields",
        step1_colombia_dependent_autochange: "If your country of residence is Colombia, your dependents must also reside in Colombia. If you continue, the country of residence of all your dependents will be changed to Colombia. Do you want to apply this change?",
        step3_colombia_dependent_disclaimer: "Dependents residing outside of Colombia cannot be added to the policyholder’s policy. Eligible dependents living outside of Colombia must obtain their own individual policy. For assistance with enrolling dependents under a separate policy, please contact our Customer Service Team at +1 (214) 276-6376 or email agentrelations@vumigroup.com.",
        footer_title: "Estimated annual cost:",
        footer_button_previous: "Previous",
        footer_button_next: "Next",
        footer_calculation_error_label: "Price not updated",
        footer_calculation_error_tooltip: "Something failed trying to update the price with your latest changes. Showing the last calculated estimate.",
    },
    es: {
        dashboard_title: "My Favorite Plan",
        dashboard_subtitle: "Aquí están tus cotizaciones guardadas",
        dashboard_new_quote: "Nueva Cotización",
        dashboard_create_plan: "Crear un nuevo My Favorite Plan",
        dashboard_table_plan_name: "Nombre del Plan",
        dashboard_table_created_date: "Fecha de Creación",
        dashboard_table_updated_date: "Fecha de Actualización",
        dashboard_table_dependents: "Dependientes",
        dashboard_table_gender: "Género",
        dashboard_table_maximum_coverage: "Cobertura Máxima",
        dashboard_table_graphical_coverage: "Cobertura Geográfica",
        dashboard_table_provider_network: "Red de Proveedores",
        dashboard_table_outpatient_benefits: "Beneficios ambulatorios",
        dashboard_table_deductible_reduction: "Reducción de deducible",
        dashboard_table_preventive_checkup: "Chequeos preventivos de salud",
        dashboard_table_maternity_complications: "Beneficios por complicaciones de maternidad",
        dashboard_table_newborn_maternity: "Recién nacido y complicaciones de maternidad",
        dashboard_table_total_times_used: "Veces Utilizado",
        dashboard_table_actions: "Acciones",
        dashboard_action_use: "Usar plan",
        dashboard_action_edit: "Editar plan",
        dashboard_action_download: "Descargar tabla de primas",
        dashboard_table_download_premium_table: "Descargar tabla de primas",
        dashboard_action_delete: "Eliminar plan",
        dashboard_download_error_title: "Error al descargar",
        dashboard_download_error_text: "No es posible descargar el documento. Inténtalo de nuevo.",
        dashboard_empty_title: "Aún no tienes planes favoritos.",
        dashboard_empty_text: "¡Crea el primero!",
        dashboard_pagination_label: "Página",
        dashboard_card_total: "Total de Plantillas",
        dashboard_card_used: "Plantillas Utilizadas",
        dashboard_card_edited: "Plantillas Editadas",
        dashboard_card_cancelled: "Plantillas Canceladas",
        dashboard_card_vs_last_month: "vs. mes anterior",
        dashboard_search_placeholder: "Buscar...",
        dashboard_search_clear: "Limpiar búsqueda",
        dashboard_filter_by: "Filtrar por:",
        dashboard_filter_country: "Por País",
        dashboard_filter_creation_date: "Por Fecha de Creación",
        dashboard_filter_created_within: "Por Fecha",
        dashboard_filter_last_month: "Último mes",
        dashboard_filter_last_3_months: "Últimos 3 meses",
        dashboard_filter_last_6_months: "Últimos 6 meses",
        dashboard_filter_last_year: "Último año",
        dashboard_filter_all_time: "Todo el tiempo",
        dashboard_sort_placeholder: "Ordenar",
        dashboard_sort_created_desc: "Creación ↓",
        dashboard_sort_created_asc: "Creación ↑",
        dashboard_sort_updated_desc: "Actualización ↓",
        dashboard_sort_updated_asc: "Actualización ↑",
        dashboard_reset_filter: "Limpiar Filtros",
        dashboard_delete_title: "¿Estás seguro de que deseas eliminar?",
        dashboard_delete_text: "Esta acción no se puede deshacer.",
        dashboard_delete_confirm: "Aceptar",
        dashboard_delete_cancel: "Cancelar",
        dashboard_delete_close: "Cerrar",
        dashboard_delete_retry: "Reintentar",
        dashboard_delete_loading_title: "Eliminando…",
        dashboard_delete_loading_text: "Espera mientras eliminamos tu plan.",
        dashboard_delete_success_title: "Plan eliminado",
        dashboard_delete_success_text: "El plan se eliminó correctamente.",
        dashboard_delete_error_title: "Ocurrió un error",
        dashboard_delete_error_text: "No pudimos eliminar el plan. Inténtalo de nuevo.",
        favorite_plan_form_base_info_title: "Información Básica",
        favorite_plan_form_base_info_subtitle: "Completa la información a continuación para comenzar a crear un plan personalizado",
        favorite_plan_form_field_age: "Edad",
        favorite_plan_form_field_needs_dependent: "¿Necesitas agregar un dependiente?",
        favorite_plan_form_field_age_range_error: "La edad debe estar entre 18 y 75 años, incluidos.",
        favorite_plan_form_load_error_title: "No pudimos cargar esta plantilla",
        favorite_plan_form_load_error_text: "Ocurrió un error al cargar tu plan favorito. Inténtalo de nuevo.",
        favorite_plan_form_load_error_retry: "Reintentar",
        favorite_plan_form_back_to_home: "Volver al Inicio",
        favorite_plan_form_unsaved_changes_message: "Tienes cambios sin guardar. ¿Estás seguro de que deseas salir de esta página? Tus cambios se perderán.",
        favorite_plan_form_leave: "Salir",
        favorite_plan_form_stay: "Permanecer",
        favorite_plan_button_save: "Guardar en My Favorite Plans",
        favorite_plan_button_update: "Actualizar My Favorite Plan",
        favorite_plan_summary_incomplete_tooltip: "Completa todos los pasos antes de guardar",
        favorite_plan_summary_stale_price_tooltip: "Actualiza el precio antes de guardar",
        favorite_plan_save_title: "Guardar en My Favorite Plans",
        favorite_plan_save_button: "Guardar",
        favorite_plan_save_cancel: "Cancelar",
        favorite_plan_save_retry: "Reintentar",
        favorite_plan_save_suggested: "Nombre sugerido",
        favorite_plan_save_placeholder: "Nombre",
        favorite_plan_save_loading_title: "Guardando…",
        favorite_plan_save_loading_text: "Espera mientras guardamos tu plan.",
        favorite_plan_save_success_title: "Plan guardado",
        favorite_plan_save_success_text: "Tu plan se guardó en My Favorite Plans.",
        favorite_plan_save_error_title: "Ocurrió un error",
        favorite_plan_save_error_text: "No pudimos guardar tu plan. Inténtalo de nuevo.",
        favorite_plan_save_go_to_dashboard: "Ir al panel",
        favorite_plan_name_field_label: "Nombre de My Favorite Plan",
        favorite_plan_save_name_available: "Nombre disponible",
        favorite_plan_save_name_checking: "Comprobando disponibilidad del nombre…",
        favorite_plan_save_name_taken: "Este nombre ya está en uso",
        favorite_plan_save_name_check_failed: "No pudimos comprobar este nombre",
        favorite_plan_save_name_invalid_length: "El nombre debe tener entre 5 y 50 caracteres",
        favorite_plan_save_name_invalid_chars: "El nombre solo puede contener letras y números",
        favorite_plan_update_title: "Actualizar My Favorite Plan",
        favorite_plan_update_button: "Actualizar",
        favorite_plan_update_loading_title: "Actualizando…",
        favorite_plan_update_loading_text: "Espera mientras actualizamos tu plan.",
        favorite_plan_update_success_title: "Plan actualizado",
        favorite_plan_update_success_text: "Tu plan se actualizó en My Favorite Plans.",
        favorite_plan_update_error_text: "No pudimos actualizar tu plan. Inténtalo de nuevo.",
        fav_plan_stale_benefits_message_generic: "Algunos beneficios de este plan ya no están disponibles. Edita el plan antes de usarlo.",
        fav_plan_stale_benefits_acknowledge: "Aceptar",
        home_welcome_back: "Bienvenido de nuevo",
        home_phrase_one: "PLANES DISEÑADOS POR TI,",
        home_phrase_two: "RESPALDADO POR VUMI®",
        home_phrase_three: "Con <strong>My VIP Care™</strong>, personalizas coberturas, eliges beneficios y ajustas cada detalle según lo que realmente valoras.",
        navbar_logout: "Cerrar Sesión",
        menu_back_to_home: "Volver al Inicio",
        menu_options_pending_fields: "Este paso tiene campos pendientes",
        step1_colombia_dependent_autochange: "Si tu país de residencia es Colombia, tus dependientes también deben residir en Colombia. Si continúas, el país de residencia de todos tus dependientes se cambiará a Colombia. ¿Deseas aplicar el cambio?",
        step3_colombia_dependent_disclaimer: "Los dependientes que residan fuera de Colombia no podrán ser añadidos a la póliza del titular. Los dependientes elegibles que vivan fuera de Colombia deberán adquirir una póliza individual propia. Para obtener asistencia con la inscripción de dependientes bajo una póliza por separado, comuníquese con nuestro Equipo de Servicio al Cliente al +1 (214) 276-6376 o envíe un correo electrónico a agentrelations@vumigroup.com.",
        footer_title: "Costo anual estimado:",
        footer_button_previous: "Anterior",
        footer_button_next: "Siguiente",
        footer_calculation_error_label: "Precio no actualizado",
        footer_calculation_error_tooltip: "Ocurrió un error al intentar actualizar el precio con tus últimos cambios. Mostrando la última estimación calculada.",
    },
    pt: {
        dashboard_title: "My Favorite Plan",
        dashboard_subtitle: "Aqui estão suas cotações salvas",
        dashboard_new_quote: "Nova Cotação",
        dashboard_create_plan: "Criar um novo My Favorite Plan",
        dashboard_table_plan_name: "Nome do Plano",
        dashboard_table_created_date: "Data de Criação",
        dashboard_table_updated_date: "Data de Atualização",
        dashboard_table_dependents: "Dependentes",
        dashboard_table_gender: "Gênero",
        dashboard_table_maximum_coverage: "Cobertura Máxima",
        dashboard_table_graphical_coverage: "Cobertura Geográfica",
        dashboard_table_provider_network: "Rede de Provedores",
        dashboard_table_outpatient_benefits: "Benefícios ambulatoriais",
        dashboard_table_deductible_reduction: "Redução de franquia",
        dashboard_table_preventive_checkup: "Check-ups preventivos de saúde",
        dashboard_table_maternity_complications: "Benefícios por complicações da maternidade",
        dashboard_table_newborn_maternity: "Recém-nascido e complicações da maternidade",
        dashboard_table_total_times_used: "Vezes Utilizado",
        dashboard_table_actions: "Ações",
        dashboard_action_use: "Usar plano",
        dashboard_action_edit: "Editar plano",
        dashboard_action_download: "Baixar tabela de prêmios",
        dashboard_table_download_premium_table: "Baixar tabela de prêmios",
        dashboard_action_delete: "Excluir plano",
        dashboard_download_error_title: "Falha no download",
        dashboard_download_error_text: "Não é possível baixar o documento. Tente novamente.",
        dashboard_empty_title: "Você ainda não tem planos favoritos.",
        dashboard_empty_text: "Crie o seu primeiro!",
        dashboard_pagination_label: "Página",
        dashboard_card_total: "Total de Modelos",
        dashboard_card_used: "Modelos Utilizados",
        dashboard_card_edited: "Modelos Editados",
        dashboard_card_cancelled: "Modelos Cancelados",
        dashboard_card_vs_last_month: "vs. mês anterior",
        dashboard_search_placeholder: "Pesquisar...",
        dashboard_search_clear: "Limpar busca",
        dashboard_filter_by: "Filtrar por:",
        dashboard_filter_country: "Por País",
        dashboard_filter_creation_date: "Por Data de Criação",
        dashboard_filter_created_within: "Por Data",
        dashboard_filter_last_month: "Último mês",
        dashboard_filter_last_3_months: "Últimos 3 meses",
        dashboard_filter_last_6_months: "Últimos 6 meses",
        dashboard_filter_last_year: "Último ano",
        dashboard_filter_all_time: "Todo o período",
        dashboard_sort_placeholder: "Ordenar",
        dashboard_sort_created_desc: "Criação ↓",
        dashboard_sort_created_asc: "Criação ↑",
        dashboard_sort_updated_desc: "Atualização ↓",
        dashboard_sort_updated_asc: "Atualização ↑",
        dashboard_reset_filter: "Limpar Filtros",
        dashboard_delete_title: "Tem certeza de que deseja excluir?",
        dashboard_delete_text: "Esta ação não pode ser desfeita.",
        dashboard_delete_confirm: "Aceitar",
        dashboard_delete_cancel: "Cancelar",
        dashboard_delete_close: "Fechar",
        dashboard_delete_retry: "Tentar novamente",
        dashboard_delete_loading_title: "Excluindo…",
        dashboard_delete_loading_text: "Aguarde enquanto excluímos seu plano.",
        dashboard_delete_success_title: "Plano excluído",
        dashboard_delete_success_text: "O plano foi excluído com sucesso.",
        dashboard_delete_error_title: "Ocorreu um erro",
        dashboard_delete_error_text: "Não foi possível excluir o plano. Tente novamente.",
        favorite_plan_form_base_info_title: "Informações Básicas",
        favorite_plan_form_base_info_subtitle: "Preencha as informações abaixo para começar a criar um plano personalizado",
        favorite_plan_form_field_age: "Idade",
        favorite_plan_form_field_needs_dependent: "Você precisa adicionar um dependente?",
        favorite_plan_form_field_age_range_error: "A idade deve estar entre 18 e 75 anos, inclusive.",
        favorite_plan_form_load_error_title: "Não foi possível carregar este modelo",
        favorite_plan_form_load_error_text: "Ocorreu um erro ao carregar seu plano favorito. Tente novamente.",
        favorite_plan_form_load_error_retry: "Tentar novamente",
        favorite_plan_form_back_to_home: "Voltar para o Início",
        favorite_plan_form_unsaved_changes_message: "Você tem alterações não salvas. Tem certeza de que deseja sair desta página? Suas alterações serão perdidas.",
        favorite_plan_form_leave: "Sair",
        favorite_plan_form_stay: "Permanecer",
        favorite_plan_button_save: "Salvar em My Favorite Plans",
        favorite_plan_button_update: "Atualizar My Favorite Plan",
        favorite_plan_summary_incomplete_tooltip: "Conclua todas as etapas antes de salvar",
        favorite_plan_summary_stale_price_tooltip: "Atualize o preço antes de salvar",
        favorite_plan_save_title: "Salvar em My Favorite Plans",
        favorite_plan_save_button: "Salvar",
        favorite_plan_save_cancel: "Cancelar",
        favorite_plan_save_retry: "Tentar novamente",
        favorite_plan_save_suggested: "Nome sugerido",
        favorite_plan_save_placeholder: "Nome",
        favorite_plan_save_loading_title: "Salvando…",
        favorite_plan_save_loading_text: "Aguarde enquanto salvamos seu plano.",
        favorite_plan_save_success_title: "Plano salvo",
        favorite_plan_save_success_text: "Seu plano foi salvo em My Favorite Plans.",
        favorite_plan_save_error_title: "Ocorreu um erro",
        favorite_plan_save_error_text: "Não foi possível salvar seu plano. Tente novamente.",
        favorite_plan_save_go_to_dashboard: "Ir para o painel",
        favorite_plan_name_field_label: "Nome do My Favorite Plan",
        favorite_plan_save_name_available: "Nome disponível",
        favorite_plan_save_name_checking: "Verificando disponibilidade do nome…",
        favorite_plan_save_name_taken: "Este nome já está em uso",
        favorite_plan_save_name_check_failed: "Não foi possível verificar este nome",
        favorite_plan_save_name_invalid_length: "O nome deve ter entre 5 e 50 caracteres",
        favorite_plan_save_name_invalid_chars: "O nome deve conter apenas letras e números",
        favorite_plan_update_title: "Atualizar My Favorite Plan",
        favorite_plan_update_button: "Atualizar",
        favorite_plan_update_loading_title: "Atualizando…",
        favorite_plan_update_loading_text: "Aguarde enquanto atualizamos seu plano.",
        favorite_plan_update_success_title: "Plano atualizado",
        favorite_plan_update_success_text: "Seu plano foi atualizado em My Favorite Plans.",
        favorite_plan_update_error_text: "Não foi possível atualizar seu plano. Tente novamente.",
        fav_plan_stale_benefits_message_generic: "Alguns benefícios deste plano não estão mais disponíveis. Edite o plano antes de usá-lo.",
        fav_plan_stale_benefits_acknowledge: "OK",
        home_welcome_back: "Bem-vindo(a) de volta",
        home_phrase_one: "PLANOS DESENHADOS PARA VOCÊ,",
        home_phrase_two: "APOIADOS PELA VUMI®",
        home_phrase_three: "Com <strong>My VIP Care™</strong>, você personaliza coberturas, escolhe benefícios e ajusta cada detalhe de acordo com o que realmente valoriza.",
        navbar_logout: "Sair",
        menu_back_to_home: "Voltar para o Início",
        menu_options_pending_fields: "Esta etapa possui campos pendentes",
        step1_colombia_dependent_autochange: "Se o seu país de residência for a Colômbia, seus dependentes também deverão residir na Colômbia. Se você continuar, o país de residência de todos os seus dependentes será alterado para a Colômbia. Deseja aplicar a alteração?",
        step3_colombia_dependent_disclaimer: "Dependentes residentes fora da Colômbia não podem ser incluídos na apólice do titular. Os dependentes elegíveis que residam fora da Colômbia deverão contratar sua própria apólice individual. Para obter assistência na inclusão de dependentes em uma apólice separada, entre em contato com nossa Equipe de Atendimento ao Cliente pelo telefone +1 (214) 276-6376 ou pelo e-mail agentrelations@vumigroup.com.",
        footer_title: "Custo anual estimado:",
        footer_button_previous: "Anterior",
        footer_button_next: "Próximo",
        footer_calculation_error_label: "Preço não atualizado",
        footer_calculation_error_tooltip: "Ocorreu uma falha ao tentar atualizar o preço com suas últimas alterações. Mostrando a última estimativa calculada.",
    }
}

export const getTexts = async (locale) => {
    const {data} = await mainApi.get(`/textos/${locale}`);
    // Local texts win: they override whatever the CMS returns for the same key.
    return { ...data, ...(localTexts[locale] ?? {}) };
}
